/* eslint-disable react/jsx-filename-extension */
import React from "react";
import PropTypes from "prop-types";
import { Fade } from "react-awesome-reveal";

export default function BenefitsSection({
  title,
  subtitle,
  benefits,
  gainsTitle,
  gains,
}) {
  return (
    <section className="py-20 bg-premium-light">
      <div className="container mx-auto px-6 max-w-4xl">

        {/* WHY CHOOSE */}
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-4">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
              Why It Matters
            </span>
          </div>
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold mb-4 text-center tracking-tight">
            {title}
          </h2>

          {subtitle && (
            <p className="text-surface-300 mb-12 text-center text-lg max-w-2xl mx-auto">{subtitle}</p>
          )}
        </Fade>

        <ul className="space-y-6 mb-16">
          {benefits.map((item) => (
            <Fade key={item.id} direction="up" delay={item.delay} triggerOnce>
              <li className="flex items-start gap-4 glass-card-static p-5 rounded-xl">
                <span className="w-8 h-8 flex-shrink-0 rounded-lg bg-brand-green-50 flex items-center justify-center mt-0.5">
                  <svg className="w-5 h-5 text-brand-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <div>
                  <p className="font-semibold text-surface-900">{item.title}</p>
                  <p className="text-sm text-surface-300 mt-1">{item.text}</p>
                </div>
              </li>
            </Fade>
          ))}
        </ul>

        {/* WHAT YOU'LL GAIN */}
        <Fade direction="up" triggerOnce>
          <div className="glass-card-static rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-surface-900 mb-6 text-center tracking-tight">
              {gainsTitle}
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {gains.map((gain) => (
                <p key={gain.id} className="flex items-center gap-3 text-surface-300">
                  <span className="green-dot flex-shrink-0" />
                  <strong className="text-surface-900 font-medium">{gain.text}</strong>
                </p>
              ))}
            </div>
          </div>
        </Fade>

      </div>
    </section>
  );
}

BenefitsSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  gainsTitle: PropTypes.string.isRequired,

  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      delay: PropTypes.number,
    }),
  ).isRequired,

  gains: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

BenefitsSection.defaultProps = {
  subtitle: "",
};
